export const blockIconsImageStyle = (
	<span className='material-symbols-outlined'>style</span>
);
